import { usePageMeta } from "../hooks/usePageMeta";
import { PageHero } from "../components/PageHero";
import { Gallery, DemoNote } from "../components/Gallery";
import { CTABand } from "../components/CTABand";

export default function Lavori() {
  usePageMeta(
    "Lavori Realizzati | Costruzioni Ciosko — Impresa Edile Veneto",
    "I lavori di Costruzioni Ciosko: ristrutturazioni, opere murarie, cartongesso, finiture, manutenzioni e cantieri in Veneto."
  );
  return (
    <>
      <PageHero
        overline="Portfolio"
        lines={["I nostri lavori"]}
        description="Ogni cantiere racconta il nostro modo di lavorare."
        image="/images/lavoro-cantiere.jpg"
      />
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-10">
          <div className="mb-10"><DemoNote /></div>
          <Gallery />
        </div>
      </section>
      <CTABand />
    </>
  );
}
